import React from "react";
import { FaArrowRight } from "react-icons/fa";
import BotComponent from "./BotComponent";
import { useState } from "react";
import { Link } from 'react-router-dom';

const ResumeSection = () => {
  const [isBotVisible, setIsBotVisible] = useState(false);

  const handleBotClose = () => {
    setIsBotVisible(false);
  };
  return (
    <section className="flex flex-col items-center mt-6 w-full liners">
      <p className="mt-2 mb-4 font-light text-base sm:text-lg text-center w-full lg:w-6/12">
        Wanna transform your ideas into reality?
      </p>
      <div className="flex gap-4 flex-wrap justify-center">
        {/* Book a Call Button */}
        <a
          href="https://cal.com/bharat-pahwa/30min"
          target="_blank"
          rel="noopener noreferrer"
          className="btn rounded-full bg-white hover:bg-black hover:text-white border-black border-2 text-black py-2 px-6 flex items-center justify-center"
        >
          <span className="font-normal">Book a Call</span>
          <FaArrowRight className="arrow ml-2 rotate-[325deg]" />
        </a>

        {/* Blogs Button */}
        <Link
          to="/blogs"
          className="btn rounded-full bg-black hover:bg-white hover:text-black border-2 border-black text-white py-2 px-6 flex items-center justify-center transition"
        >
          <span className="font-normal">Blogs</span>
          <FaArrowRight className="arrow ml-2 rotate-[325deg]" />
        </Link>
      </div>
      <BotComponent isVisible={isBotVisible} onClose={handleBotClose} />
    </section>
  );
};

export default ResumeSection;




